/**
 * Holds the Still unsure? card under the product gallery (snippets/custom-gallery-aside.liquid).
 * Records the gallery column's height as --ac-gallery-column-height, which the sticky gallery
 * rule in custom-product-information-styles uses to pin a column taller than the window by its
 * bottom edge, so the thumbnails and the card are never cut off.
 */
class GalleryAside extends HTMLElement {
  /** @type {ResizeObserver | undefined} */
  #observer;

  connectedCallback() {
    const column = this.closest('.product-information__media');
    if (!(column instanceof HTMLElement)) return;

    this.#observer = new ResizeObserver(() => {
      column.style.setProperty('--ac-gallery-column-height', `${column.offsetHeight}px`);
    });
    this.#observer.observe(column);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('ac-gallery-aside')) {
  customElements.define('ac-gallery-aside', GalleryAside);
}
